<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button icon-only (click)="onDismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title> Review merge details </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <form [formGroup]="clientForm">
    <salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>

    <ion-list>
      <ion-item-group>
        <ion-item lines="none">
          <ion-label position="stacked">First Name*</ion-label>
          <ion-input
            type="text"
            name=""
            formControlName="firstName"
            clearInput
          ></ion-input>
        </ion-item>
        <ion-item lines="none" *ngIf="!firstName.valid && submitAttempt">
          <p *ngIf="firstName.hasError('required')" class="sm-error">
            Oops, a first name is required.
          </p>

          <p *ngIf="firstName.hasError('maxlength')" class="sm-error">
            A first name can't exceed 30 letters.
          </p>
        </ion-item>

        <ion-item lines="none" *ngIf="mergeFromFirstName">
          <ion-button
            icon-left
            fill="clear"
            (click)="
              swapTemp = firstName.value;
              firstName.setValue(mergeFromFirstName);
              mergeFromFirstName = swapTemp
            "
          >
            <ion-icon name="swap-horizontal"></ion-icon>&nbsp; Switch to
            {{ mergeFromFirstName }}
          </ion-button>
        </ion-item>

        <ion-item lines="none">
          <ion-label position="stacked">Last Name</ion-label>
          <ion-input
            type="text"
            name=""
            formControlName="lastName"
            clearInput
          ></ion-input>
        </ion-item>
        <ion-item lines="none" *ngIf="!lastName.valid && submitAttempt">
          <p *ngIf="lastName.hasError('maxlength')" class="sm-error">
            A last name can't exceed 35 letter.
          </p>
        </ion-item>

        <ion-item lines="none" *ngIf="mergeFromLastName">
          <ion-button
            icon-left
            fill="clear"
            (click)="
              swapTemp = lastName.value;
              lastName.setValue(mergeFromLastName);
              mergeFromLastName = swapTemp
            "
          >
            <ion-icon name="swap-horizontal"></ion-icon>&nbsp; Switch to
            {{ mergeFromLastName }}
          </ion-button>
        </ion-item>
      </ion-item-group>

      <ion-item-group>
        <ion-item lines="none">
          <ion-label position="stacked">Email</ion-label>
          <ion-input
            type="email"
            name="email"
            formControlName="email"
            clearInput
          ></ion-input>
        </ion-item>

        <ion-item lines="none" *ngIf="!email.valid && submitAttempt">
          <p *ngIf="email.hasError('validateEmail')" class="sm-error">
            Oops, that email is invalid.
          </p>

          <p *ngIf="email.hasError('maxlength')" class="sm-error">
            An email can't exceed 100 characters.
          </p>
        </ion-item>

        <ion-item lines="none" *ngIf="mergeFromEmail">
          <ion-button
            icon-left
            fill="clear"
            (click)="
              swapTemp = email.value;
              email.setValue(mergeFromEmail);
              mergeFromEmail = swapTemp
            "
          >
            <ion-icon name="swap-horizontal"></ion-icon>&nbsp; Switch to
            {{ mergeFromEmail }}
          </ion-button>
        </ion-item>

        <ion-item lines="none">
          <ion-label position="stacked">Home Phone</ion-label>
          <ion-input
            type="tel"
            name=""
            formControlName="phone1"
            clearInput
          ></ion-input>
        </ion-item>

        <ion-item lines="none" *ngIf="!phone1.valid && submitAttempt">
          <p *ngIf="phone1.hasError('maxlength')" class="sm-error">
            Oops, this can't be longer than 20 characters.
          </p>

          <p *ngIf="phone1.hasError('validatePhone')" class="sm-error">
            Oops, this phone is invalid.
          </p>
        </ion-item>

        <ion-item lines="none" *ngIf="mergeFromPhone1">
          <ion-button
            icon-left
            fill="clear"
            (click)="
              swapTemp = phone1.value;
              phone1.setValue(mergeFromPhone1);
              mergeFromPhone1 = swapTemp
            "
          >
            <ion-icon name="swap-horizontal"></ion-icon>&nbsp; Switch to
            {{ mergeFromPhone1 }}
          </ion-button>
        </ion-item>

        <ion-item lines="none">
          <ion-label position="stacked">Mobile Phone</ion-label>
          <ion-input
            type="tel"
            name=""
            formControlName="phone2"
            clearInput
          ></ion-input>
        </ion-item>

        <ion-item lines="none" *ngIf="!phone2.valid && submitAttempt">
          <p *ngIf="phone2.hasError('maxlength')" class="sm-error">
            Oops, this can't be longer than 20 characters.
          </p>
          <p *ngIf="phone2.hasError('validatePhone')" class="sm-error">
            Oops, this phone is invalid.
          </p>
        </ion-item>

        <ion-item lines="none" *ngIf="mergeFromPhone2">
          <ion-button
            icon-left
            fill="clear"
            (click)="
              swapTemp = phone2.value;
              phone2.setValue(mergeFromPhone2);
              mergeFromPhone2 = swapTemp
            "
          >
            <ion-icon name="swap-horizontal"></ion-icon>&nbsp; Switch to
            {{ mergeFromPhone2 }}
          </ion-button>
        </ion-item>

        <ion-item lines="none">
          <ion-label position="stacked">Work Phone</ion-label>
          <ion-input
            type="tel"
            name=""
            formControlName="workPh"
            clearInput
          ></ion-input>
        </ion-item>

        <ion-item lines="none" *ngIf="!workPh.valid && submitAttempt">
          <p *ngIf="workPh.hasError('maxlength')" class="sm-error">
            Oops, this can't be longer than 20 characters.
          </p>
        </ion-item>

        <ion-item lines="none" *ngIf="mergeFromWorkPh">
          <ion-button
            icon-left
            fill="clear"
            (click)="
              swapTemp = workPh.value;
              workPh.setValue(mergeFromWorkPh);
              mergeFromWorkPh = swapTemp
            "
          >
            <ion-icon name="swap-horizontal"></ion-icon>&nbsp; Switch to
            {{ mergeFromWorkPh }}
          </ion-button>
        </ion-item>
      </ion-item-group>

      <ion-item-group>
        <ion-item lines="none">
          <ion-label position="stacked">Address 1</ion-label>
          <ion-input
            type="text"
            name=""
            formControlName="address1"
            clearInput
          ></ion-input>
        </ion-item>

        <ion-item lines="none" *ngIf="!address1.valid && submitAttempt">
          <p *ngIf="address1.hasError('maxlength')" class="sm-error">
            Oops, this can't be longer than 40 characters.
          </p>
        </ion-item>

        <ion-item lines="none" *ngIf="mergeFromAddress1">
          <ion-button
            icon-left
            fill="clear"
            (click)="
              swapTemp = address1.value;
              address1.setValue(mergeFromAddress1);
              mergeFromAddress1 = swapTemp
            "
          >
            <ion-icon name="swap-horizontal"></ion-icon>&nbsp; Switch to
            {{ mergeFromAddress1 }}
          </ion-button>
        </ion-item>

        <ion-item lines="none">
          <ion-label position="stacked">Address 2</ion-label>
          <ion-input
            type="text"
            name=""
            formControlName="address2"
            clearInput
          ></ion-input>
        </ion-item>

        <ion-item lines="none" *ngIf="!address2.valid && submitAttempt">
          <p *ngIf="address2.hasError('maxlength')" class="sm-error">
            Oops, this can't be longer than 40 characters.
          </p>
        </ion-item>

        <ion-item lines="none" *ngIf="mergeFromAddress2">
          <ion-button
            icon-left
            fill="clear"
            (click)="
              swapTemp = address2.value;
              address2.setValue(mergeFromAddress2);
              mergeFromAddress2 = swapTemp
            "
          >
            <ion-icon name="swap-horizontal"></ion-icon>&nbsp; Switch to
            {{ mergeFromAddress2 }}
          </ion-button>
        </ion-item>

        <ion-item lines="none">
          <ion-label position="stacked">City</ion-label>
          <ion-input
            type="text"
            name=""
            formControlName="city"
            clearInput
          ></ion-input>
        </ion-item>

        <ion-item lines="none" *ngIf="!city.valid && submitAttempt">
          <p *ngIf="city.hasError('maxlength')" class="sm-error">
            Oops, this can't be longer than 20 characters.
          </p>
        </ion-item>

        <ion-item lines="none" *ngIf="mergeFromCity">
          <ion-button
            icon-left
            fill="clear"
            (click)="
              swapTemp = city.value;
              city.setValue(mergeFromCity);
              mergeFromCity = swapTemp
            "
          >
            <ion-icon name="swap-horizontal"></ion-icon>&nbsp; Switch to
            {{ mergeFromCity }}
          </ion-button>
        </ion-item>

        <ion-item lines="none">
          <ion-label position="stacked">Province</ion-label>
          <ion-input
            type="text"
            name=""
            formControlName="province"
            clearInput
          ></ion-input>
        </ion-item>

        <ion-item lines="none" *ngIf="!province.valid && submitAttempt">
          <p *ngIf="province.hasError('maxlength')" class="sm-error">
            Oops, this can't be longer than 25 characters.
          </p>
        </ion-item>

        <ion-item lines="none" *ngIf="mergeFromProvince">
          <ion-button
            icon-left
            fill="clear"
            (click)="
              swapTemp = province.value;
              province.setValue(mergeFromProvince);
              mergeFromProvince = swapTemp
            "
          >
            <ion-icon name="swap-horizontal"></ion-icon>&nbsp; Switch to
            {{ mergeFromProvince }}
          </ion-button>
        </ion-item>

        <ion-item lines="none">
          <ion-label position="stacked">Postal</ion-label>
          <ion-input
            type="text"
            name=""
            formControlName="postal"
            clearInput
          ></ion-input>
        </ion-item>

        <ion-item lines="none" *ngIf="!postal.valid && submitAttempt">
          <p *ngIf="postal.hasError('maxlength')" class="sm-error">
            Oops, this can't be longer than 25 characters.
          </p>
        </ion-item>

        <ion-item lines="none" *ngIf="mergeFromPostal">
          <ion-button
            icon-left
            fill="clear"
            (click)="
              swapTemp = postal.value;
              postal.setValue(mergeFromPostal);
              mergeFromPostal = swapTemp
            "
          >
            <ion-icon name="swap-horizontal"></ion-icon>&nbsp; Switch to
            {{ mergeFromPostal }}
          </ion-button>
        </ion-item>

        <ion-item lines="none">
          <ion-label position="stacked">Notes</ion-label>
          <ion-textarea formControlName="notes"></ion-textarea>
        </ion-item>
      </ion-item-group>
    </ion-list>
  </form>
</ion-content>

<ion-footer class="ion-no-border ion-no-margin">
  <ion-toolbar>
    <ion-row>
      <ion-col>
        <ion-button
          (click)="onClientSave()"
          color="primary"
          expand="block"
          ng-reflect-color="primary"
        >
          Complete merge
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-toolbar>
</ion-footer>
